import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    treatmentPlan: null,
    fetching: false,
    error: null,
    hasChanged: false,
}


export default handleActions({
    [type.TREATMENT_PLAN_LOADED]: (state, action) => {
        const { treatmentPlan } = action.payload
        return {
            ...state,
            treatmentPlan,
        }
    },
    [type.CHANGE_TREATMENT_PLAN]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            hasChanged: true,
            treatmentPlan: {
                ...state.treatmentPlan,
                [name]: value,
            },
        }
    },
    [type.CHANGE_SEGMENT]: (state, action) => {
        const { segment, name, value } = action.payload
        const segmentValue = state.treatmentPlan[segment] || {}
        return {
            ...state,
            hasChanged: true,
            treatmentPlan: {
                ...state.treatmentPlan,
                [segment]: {
                    ...segmentValue,
                    [name]: value,
                },
            },
        }
    },
    [type.SAVE_TREATMENT_PLAN_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_TREATMENT_PLAN_SUCCESS]: (state, action) => {
        const { treatmentPlan } = action.payload
        return {
            ...state,
            fetching: false,
            treatmentPlan,
        }
    },
    [type.SAVE_TREATMENT_PLAN_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },


}, initialState)



// WEBPACK FOOTER //
// ./src/modules/treatment/state/plan/reducer.js